export const UserTypes = {
    SIGN_IN: 'SIGN_IN',
    SIGN_OUT: 'SIGN_OUT',
    CAMBIAR_ZONA: 'CAMBIAR_ZONA',
    CAMBIAR_PUNTOS_POLIGONOS: 'CAMBIAR_PUNTOS_POLIGONOS',
    CAMBIAR_UBICACION: 'CAMBIAR_UBICACION',
    CAMBIAR_CONFIGURACION: 'CAMBIAR_CONFIGURATION',
    CAMBIAR_CODIGO_ALERTA: 'CAMBIAR_CODIGO_ALERTA'
}